import { useMutation } from '@apollo/client';
import { CREATE_LXP_FILE, NOTIFY_LXP_FILE, CREATE_RESOURCE_FILE, CREATE_ASSET } from '../gql/mutations';
import { v4 as uuidv4 } from 'uuid';

export const useUploadLXPFile = () => {
    const [ createLXPFile ] = useMutation( CREATE_LXP_FILE );
    const [ notifyLxpFileUploaded ] = useMutation( NOTIFY_LXP_FILE );
    const [ createResourceFile ] = useMutation( CREATE_RESOURCE_FILE );
    const [ createAsset ] = useMutation( CREATE_ASSET );
    
    const uploadFile = async ( { file, resourceId, createFileAsset = false } ) => {
        let id;
        let signedURL;

        /////////////////////////////////
        // 1. Do createLXPFile mutation
        /////////////////////////////////        

        try {
            const variables = {
                'input': {
                    'name': `${ file.name }`, 
                    'filename': file.name,
                    'mimetype': file.type
                }
            };

            const result = await createLXPFile( { variables } );   
            id = result?.data?.result?.id;
            signedURL = result?.data?.result?.signedUrl;

            if ( !signedURL || !id ) {
                console.error( 'Error creating LXP file' );
                return { error: true };  
            }
        } catch ( error )  {
            console.error( 'Error creating LXP file: ', error );
            return { error: true };
        }
        
        /////////////////////////////////
        // 2. POST/upload the file
        /////////////////////////////////

        try {
            const response = await fetch( signedURL, {
                method: 'PUT',
                headers: { 'Content-Type': file.type },
                body: file
            } );

            if ( !response.ok ) {
                throw new Error( `Upload failed: ${ response.status }` );
            }
        } catch ( error ) {
            console.error( 'Error uploading file: ', error );
            return { error: true };
        }
        
        /////////////////////////////////        
        // 3. Do notifyLXPFile mutation
        /////////////////////////////////        

        try {
            const variables = {
                'input': {
                    'id': id 
                }
            };

            const result = await notifyLxpFileUploaded( { variables } );
            id = result?.data?.result?.id;
             
            if ( !id ) {
                console.error( 'Error notify LXP file uploaded' );
                return { error: true };  
            }
        } catch ( error )  {
            console.error( 'Error notify LXP file uploaded: ', error );
            return { error: true };
        }
        
        //////////////////////////////////////        
        // 4. Do createResourceFile mutation
        //////////////////////////////////////        
        
        if ( resourceId ) {

            try {
                const variables = {
                    'input': {
                        'resourceId': resourceId, 
                        'lxpFileId': id
                    }
                };
        
                const response = await createResourceFile( { variables } );
                const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
                
                if ( success ) {
                    return response?.data?.result?.id;
                } else {
                    console.error( 'Error at createResourceFile' );
                    return { error: true };
                } 
            } catch ( error ) { 
                console.error( 'Error at createResourceFile', error );
                return { error: true };
            }
        } else {
            if ( createAsset ) {
                try {
                    const variables = {
                        'input': {
                            id: uuidv4(),
                            type: 'FILE',
                            name: file.name, 
                            mimetype: file.type,
                            lxpFileId: id
                        }
                    };
                    
                    const response = await createAsset( { variables } );
                    const success = !( response?.error || response?.errors && response?.errors?.length > 0 );
                    
                    if ( success ) {
                        return response?.data?.result?.id;
                    } else {
                        console.error( 'Error at createAsset' );
                        return { error: true };
                    } 
                } catch ( error ) { 
                    console.error( 'Error at createAsset', error );
                    return { error: true };
                }
            } else {
                return id;
            }
        }
    };

    return {
        uploadFile
    };
};
